import { useEffect } from 'react';
import { useSelectedBot } from '../contexts/SelectedBotContext.js';

const API = process.env.REACT_APP_API_BASE_URL;

// Bridges the unread-leads count for the GLOBALLY selected bot up to the App
// shell (which renders the sidebar badge). Re-fetches whenever the header bot
// selection changes. Must be rendered inside SelectedBotProvider.
function LeadCountBridge({ setCount }) {
  const { selectedBotId } = useSelectedBot();

  useEffect(() => {
    const userId = localStorage.getItem('user_id');
    if (!userId || !selectedBotId) {
      setCount(0);
      return undefined;
    }
    let alive = true;
    (async () => {
      try {
        const res = await fetch(
          `${API}leads/unread/count?user_id=${userId}&bot_id=${selectedBotId}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        if (!res.ok) return;
        const data = await res.json();
        if (alive) setCount(data.unread_leads_count || 0);
      } catch {
        /* keep the previous count on a transient failure */
      }
    })();
    return () => {
      alive = false;
    };
  }, [selectedBotId, setCount]);

  return null;
}

export default LeadCountBridge;
